import { ValidatorFn, AbstractControl } from '@angular/forms';

export class GCValidators {

  static minValue = function (minValue): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      const value = control.value;

      return (value >= minValue) ? null : {
        validateNumber: {
          valid: false,
          errorMessage: 'Zahl muss größer als ' + minValue + ' sein',
        },
      };
    };
  };

  static maxValue = function (maxValue): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      const value = control.value;

      return (value <= maxValue) ? null : {
        validateNumber: {
          valid: false,
          errorMessage: 'Zahl muss kleiner als ' + maxValue + ' sein',
        },
      };
    };
  };

  static minLength = function (minLength): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      const value = control.value;
      const valueLength = String(value).length;

      return (valueLength >= minLength) ? null : {
        validateNumber: {
          valid: false,
          errorMessage: 'Zahl muss mindestens ' + minLength + ' Stellen haben',
        },
      };
    };
  };

  static maxLength = function (maxLength): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      const value = control.value;
      const valueLength = String(value).length;

      return (valueLength <= maxLength) ? null : {
        validateNumber: {
          valid: false,
          errorMessage: 'Zahl darf maximal ' + maxLength + ' Stellen haben',
        },
      };
    };
  };

  static validateEmail = function (): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      const value = control.value;

      /* tslint:disable */
      const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      /* tslint:enable */

      return (value.length > 0) ? EMAIL_REGEXP.test(value) ? null : {
        validateEmail: {
          valid: false,
          error: 'Bitte korrekte E-Mail-Adresse angeben',
        },
      } : null;
    };
  };

  static validateTime = function (): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      const value = control.value;

      /* tslint:disable */
      const TIME_REGEXP = /^([0-9]|0[0-9]|1[0-9]|2[0-4]):[0-5][0-9]$/;
      /* tslint:enable */

      return (value.length === 0) || !TIME_REGEXP.test(value) ? {
        validateTime: {
          valid: false,
          error: 'Bitte korrekte Zeit angeben',
        },
      } : null;
    };
  };

  static validatePassword = function (): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      const value = control.value;

      const minLowerCase = 1;
      const minUpperCase = 1;
      const minDecimals = 1;
      const minSpecialChars = 0;
      const minChars = Math.max(
        8,
        (minLowerCase + minUpperCase + minDecimals + minSpecialChars),
      );

      const PASSWORD_REGEXP = new RegExp(
        '(?=.*\\d)(?=.*[a-z]{' + minLowerCase + ',})' +
        '(?=.*[A-Z]{' + minUpperCase + ',})' +
        '(?=.*[0-9]{' + minDecimals + ',})' +
        '(?=(.*\\W){' + minSpecialChars + '})' +
        '.{' + minChars + ',}',
      );

      return PASSWORD_REGEXP.test(value) ? null : {
        validatePassword: {
          valid: false,
          errorMessage: 'Ihr Passwort sollte min. 8 Zeichen lang sein und einen Groß- und Kleinbuchstaben und eine Zahl enthalten.', // TODO: Better Error Message
        },
      };
    };
  };

  static validatePasswordComparison = function () {
    return (control: AbstractControl): { [key: string]: any } => {
      const value = control.value;

      return (control.parent) ? (control.parent.controls['password'].value === value) ? null : {
        validatePasswordComparison: {
          valid: false,
          errorMessage: 'Passwörter stimmen nicht überein',
        },
      } : null;
    };
  };

  static validatePhone = function () {
    return (control: AbstractControl): { [key: string]: any } => {
      const value = control.value;

      const PHONE_REGEXP = /^(?=.*[0-9]).{5}$/;

      return (value.length > 0) ? PHONE_REGEXP.test(value) ? null : {
        validatePhone: {
          valid: false,
          errorMessage: 'Keine korrekte Telefonnummer',
        },
      } : null;
    };
  };
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/shared/validators/gc-validator.ts